import { render, staticRenderFns } from "./FileImageComponent.vue?vue&type=template&id=5572c70a&scoped=true&"
import script from "./FileImageComponent.vue?vue&type=script&lang=js&"
export * from "./FileImageComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5572c70a",
  null
  
)

export default component.exports